import './CardContent.scss'

const CardContent = ({ children }) => {
  return <div id="dashboard-layout-card-content">{children}</div>
}

export default CardContent
